import moment from 'moment'

const prepareShow = moving => {
  const gotInOut = moment(moving.go_in_out, 'YYYYMMDD').format('YYYY-MM-DD')
  const isBefore = moment(gotInOut).isBefore(moment(new Date(), 'YYYYMMDD').format('YYYY-MM-DD'))
  if (isBefore) {
    moving._lock_go_in_out = true
  }
  moving.go_in_out = moment(moving.go_in_out, 'YYYYMMDD').format('DD/MM/YYYY')
  return moving
}

const prepareSearch = (search) => {
  search.generic = search.generic
  return search
}

export default {
  prepareShow,
  prepareSearch,
  doFilterSearch () {
    this.setPage(1)
  },
  doClearSearch () {
    this.search.generic = null
    this.doLoadAll()
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/moving/index/resources/methods.js